import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'linescape-exhibit-intermodal-europe-amsterdam',
  template: require('./linescape-exhibit-intermodal-europe-amsterdam.component.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-exhibit-intermodal-europe-amsterdam.component.scss')]
})
export class LinescapeExhibitIntermodalEuropeAmsterdamComponent extends BlogPage {
  title = "Linescape to exhibit at Intermodal Europe in Amsterdam - Linescape";
  description = "Search Engine to unveil new developments at Intermodal, Nov. 30 - Dec. 2, 2010.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-exhibit-intermodal-europe-amsterdam/linescape-exhibit-intermodal-europe-amsterdam.component.ts